/**
 * Anchor Block JavaScript
 * 
 * Note: Smooth scroll functionality is handled globally in main.js
 * This file can be used for anchor-block specific functionality if needed
 */

console.log('Anchor block initialized');


// Only handle anchor clicks inside section.cta
document.addEventListener('click', function(event) {
    const anchor = event.target.closest('a[href*="#"]');
    if (anchor) {
        const sectionAnchor = anchor.closest('a[href*="#"]');
        if (sectionAnchor) {
            // Exclude if inside .menu-overlay
            if (sectionAnchor.closest('.menu-overlay')) return;
            console.log("anchor click");
            event.preventDefault();
            const targetId = sectionAnchor.getAttribute('href').split('#')[1];
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.getBoundingClientRect().top + window.pageYOffset - 50,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }
});